import { cn } from '@/shared/lib/cn';
import type { PreviewHint } from './previewModel';

/** Hinweise je Code mit Zahl der Tage; der rohe Code bleibt klein lesbar (Board „Hinweise“). */
export function PricingPreviewCodes({ hints }: { hints: PreviewHint[] }) {
  if (hints.length === 0) return null;
  return (
    <section className="flex flex-col gap-1.5">
      <span className="text-ink-soft font-mono text-[10px] font-semibold uppercase tracking-[0.16em]">
        Hinweise
      </span>
      <ul className="flex flex-col gap-1.5">
        {hints.map((hint) => (
          <li
            key={hint.code}
            className={cn(
              'rounded-control px-3 py-2.5 text-[13px]',
              hint.tone === 'amber' ? 'bg-amber-tint text-ink' : 'bg-card-alt text-ink',
            )}
          >
            {hint.days !== null && <b>{hint.days === 1 ? '1 Tag' : `${hint.days} Tage`} · </b>}
            {hint.text}
            <code className="text-ink-soft ml-1.5 break-all font-mono text-[11px]">
              {hint.code}
            </code>
          </li>
        ))}
      </ul>
    </section>
  );
}
